import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '../constants';
import type { RootState } from '../app/store';
import type { User } from '../types/User';

export interface AuthState {
  token: string | null;
  tempToken: string | null;
  userData: User | null;
}

const getStoredUserData = (): User | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.userData);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const initialState: AuthState = {
  token: localStorage.getItem(STORAGE_KEYS.token) || null,
  tempToken: localStorage.getItem(STORAGE_KEYS.tempToken) || null,
  userData: getStoredUserData(),
};

const authSlice = createSlice({
  name: 'auth',

  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ token: string; userData: any }>) => {
      state.token = action.payload.token;
      state.userData = action.payload.userData;
      localStorage.setItem(STORAGE_KEYS.token, action.payload.token);
      if (action.payload.userData) {
        try {
          localStorage.setItem(STORAGE_KEYS.userData, JSON.stringify(action.payload.userData));
        } catch {}
      }
    },
    setUserData: (state, action: PayloadAction<any>) => {
      if (!action.payload || typeof action.payload !== 'object') return;
      const merged = { ...(state.userData || {}), ...action.payload };
      state.userData = merged;
      try {
        localStorage.setItem(STORAGE_KEYS.userData, JSON.stringify(merged));
      } catch {}
    },
    resetAuth: (state) => {
      state.token = null;
      state.tempToken = null;
      state.userData = null;
      localStorage.removeItem(STORAGE_KEYS.token);
      localStorage.removeItem(STORAGE_KEYS.tempToken);
      localStorage.removeItem(STORAGE_KEYS.userData);
    },
  },
});

export const { setAuth, setUserData, resetAuth } = authSlice.actions;
export const getCurrentUser = (state: RootState) => state.auth.userData;
export default authSlice.reducer;
